module.exports = __webpack_public_path__ + "fannie-mae-card-bottom-left@2x.1Z3X5X1q.png";